<template>
  <div id="home" style="background-color:white">
  
  <h1>Oh no! The page you are looking for can't be found!</h1>
<!-- <h1>Ooops</h1> -->

  </div>
</template>

<script>
import {fb} from './firebaseconfig'
// import draggable from 'vuedraggable'
// import linkinfo from "./linkinfo_component";
// import siteicon from "./siteicon_component";



let db = fb.database();

export default {
  components: {
      // draggable,
      // linkinfo,
      // siteicon,
  },
  name: 'NotFound',
  data () {
    return {
    }
  },
  mounted: function() {
  },
  firebase: function(){ 
    // this.loadingStatus = true
    return{
        // sites: {source: db.ref('customsite/').orderByChild('site'),anObject: false, cancelCallback: function() {}, readyCallback: function(){
        //   }},
        // ads: db.ref('ads')
        // ads: db.ref('ads')//.orderByChild('active')
    }
  },
  computed:{

},
  methods: {

}
}
</script>

<style>

body, h1{
  /* background-color: "whitesmoke"; */
  font-family: GoogleSans,Roboto, "Noto Sans", Noto, sans-serif !important;
  font-weight:bolder !important;
  display:flex;
  justify-content: center;
  text-transform: uppercase;
  height: 100vh;
    display: flex;
    align-content: center;
    align-items: center;
    line-height: normal;
  padding:10px;
}

#app{
  /* border:5px solid #E4B2F3; */
  padding:10px;
  border-radius:50px;
  overflow:hidden;
}

.md-tabs-navigation{
  position: fixed !important;
    width: 100%;
}

.md-tabs-content{
  margin-top:50px;
}
.fullScreenDialog .md-dialog{
  min-width: 100%;
  max-width: 100%;
  width:100%;
  /* max-height: calc(100% - 48px); */
  max-height:100%;
  height: 100%;
  /* height: calc(100% - 48px); */
  
  top: 0px;
}

/* #selectSite .md-dialog {
  max-width: 100%;
  max-height: calc(100% - 48px);
  top: 24px;
} */

/* #addSite .md-dialog {
  max-width: 100%;
  width:100%;
  max-height: calc(100% - 48px);
  height: calc(100% - 48px);
  top: 24px;
} */

.userInformation{
  margin:unset;
}

.userInformation .md-list-item-container{
  padding: 0px 0px 10px 0px;
}

.md-list-item .md-button:not(.md-button-ghost):not(.md-list-item-container) {
  padding: unset;
  margin-bottom: 5px;
  height: unset;
  min-height: unset;
  width: unset;
  min-width: 22px;
}

.pictureUploader input{
  display: none
}
</style>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

.handle {
  z-index: 4;
  margin-right:5px
}

.linkEditorContainer{
  padding:20px;
  border-bottom-color:silver;
  border-bottom-width:1px;
  border-bottom-style:solid;
}

.md-select-content{
  width:100% !important;
}

#toolbar{
  position:sticky;
  z-index:1 ;
}

body{
  background-color: "whitesmoke";
}

section{
  padding-bottom:30px;
}

h1, h2 {
  font-weight: normal;
  /* font-family: 'Pacifico'; */
  text-align: center;
}

h2{
  font-size:10ex;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

#toolbar{
  position:sticky;
  position: -webkit-sticky;
  top:0px;
}

#profileBackground{
  background-color:white;
  padding-top:15px;
  background-position: center;
  background-repeat: no-repeat;
  /* background-size:cover; */
  background-size: 150vw;
  text-align: center;
}

#profilePic{
  background-position: center;
  background-repeat: no-repeat;
  background-size:cover;
  /* width: 100px;
  height: 100px;
  max-width: 100px;
  max-height: 100px; */
  -webkit-border-radius: 50%;
  -moz-border-radius: 50%;
  border-radius: 50%;
  border: 3px solid rgba(255, 255, 255, .75);
  margin-left:auto;
  margin-right:auto;
}

#slinkName{
  color:black;
  font-size:18px;
  margin-top:10px;
  margin-bottom:10px;
  padding-left:10px;
  padding-right:10px;
  background-color:rgba(0, 0, 0, 0.25);
  white-space:nowrap;
  display:inline-block;
  border-radius:10px;
}

.md-list-item-container{
  padding: 10px 16px;
}

.md-tab{
  padding:unset;
  padding-top:20px;
  padding-bottom:48px
}

.compactContainer{
  padding: unset;
  min-height: unset;
  margin-bottom: 12px;
  font-size:12px !important
}

.userSearchBar{
  width:100%;
  background-color:silver
}


</style>


// WEBPACK FOOTER //
// src/components/404.vue